import { Component, EventEmitter, input, Input, Output} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DxControlUtilsService } from '../../../_common/dx-control-utils.service';
import { BaseFieldComponent } from '../BaseField/basefield.component';
import { BaseComponent } from '../../../_common/dx-base-component';

@Component({
    selector: 'dx-inputField',
    templateUrl: './InputField.component.html',
    styleUrls: ['./InputField.component.scss'],
    standalone: false
})
export class InputFieldComponent extends BaseComponent {
    @Input() fieldType: string = 'text';
    @Input() options: any[] = [];
    @Input() placeHolder: string = '';
    @Input() size: string = 'large';
    @Input() formFields: FormBuilder = new FormBuilder();
    @Input() visible: boolean = true;

    @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
    constructor(private textControlSvc: DxControlUtilsService){
       super(textControlSvc);

    }
    override ngOnInit() {
        super.ngOnInit();
        this.componentName = 'InputFieldComponent';
    }   
    onValueChange(event: any){
        this.value = event;
        this.onChange.emit(event);
        this.valueChange.emit(event);
    }
    getValue(){
        return this.value;
    }
    setValue(val: any){
        this.value = val;
    }

}
